import React from "react";
import { PieChart, Pie, Cell } from "recharts";
import { Loader } from "lucide-react";

export default function StatusDonut({ donutData, donutTotal, loading }) {
    return (
        <div className="bg-[#111827] border border-[#1F2937] rounded-xl p-4 flex-1">
            <p className="text-sm font-bold text-white mb-3">Active Shipments By Status</p>
            {loading ? (
                <div className="flex items-center justify-center h-28 text-slate-700">
                    <Loader size={20} className="animate-spin"/>
                </div>
            ) : (
                <div className="flex items-center gap-4">
                    <div className="relative shrink-0" style={{width:110,height:110}}>
                        <PieChart width={110} height={110}>
                            <Pie
                                data={donutTotal > 0 ? donutData : [{ name:"No Data", value:1, color:"#1F2937" }]}
                                cx={50} cy={50}
                                innerRadius={32} outerRadius={50}
                                dataKey="value" startAngle={90} endAngle={-270}
                                paddingAngle={donutTotal > 0 ? 2 : 0}
                                isAnimationActive={false}
                            >
                                {(donutTotal > 0 ? donutData : [{color:"#1F2937"}]).map((d,i) => (
                                    <Cell key={i} fill={d.color}/>
                                ))}
                            </Pie>
                        </PieChart>
                        <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
                            <p className="text-xl font-bold text-white leading-none">{donutTotal}</p>
                            <p className="text-[9px] text-slate-500">Total</p>
                        </div>
                    </div>
                    <div className="flex flex-col gap-1.5 flex-1">
                        {donutData.map(d => (
                            <div key={d.name} className="flex items-center justify-between text-xs">
                                <span className="flex items-center gap-1.5 text-slate-300">
                                    <span className="w-2 h-2 rounded-full shrink-0" style={{backgroundColor:d.color}}/>
                                    {d.name}
                                </span>
                                <span className="text-slate-400 tabular-nums">
                                    {d.value}
                                    {donutTotal > 0 && (
                                        <span style={{color:d.color}} className="ml-1">
                                            ({((d.value/donutTotal)*100).toFixed(1)}%)
                                        </span>
                                    )}
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
